import { UserSpecialty, UserSpecialtyId } from './user';
import { TranslatedText } from './global';

export interface RamqContextElementDTO {
  code: string;
  description: string;
  translatedDescription: TranslatedText;
  effectiveEndDate: number | null;
  effectiveStartDate: number;
}

export interface RamqDiagnosticDTO {
  code: string;
  description: string;
  translatedDescription: TranslatedText;
  effectiveEndDate: number | null;
  effectiveStartDate: number;
  medicalClassificationSystemId: string;
}

export interface RamqExplicativeMessageDTO {
  type: string | null;
  category: string;
  code: string;
  message: string;
  translatedMessage: TranslatedText;
  effectiveEndDate: number | null;
  effectiveStartDate: number;
}

export interface RamqFacilityDTO {
  number: string;
  name: string;
  numbers: Array<{ number: string; effectiveStartDate: number; effectiveEndDate: number | null }>;
  address: string;
  city: string;
  zipCode: string;
  category: string;
  type: string | null;
  rssCode: number | null;
  daysOff: string[];
  isCMS: boolean;
  isCRDS: boolean;
  isCabinet: boolean;
}

export interface RamqGeographicLocationDTO {
  number: string;
  name: string;
  regionName: string | null;
  regionNumber: string | null;
  effectiveStartDate: number;
  effectiveEndDate: number | null;
}

export enum RamqSpecialistActCodeNatureType {
  ADMINISTRATIF = 'Administratif',
  ANESTHESIOLOGIE = 'Anesthésiologie',
  BIOCHIMIE_MEDICALE = 'Biochimie médicale',
  CHIRURGIE = 'Chirurgie',
  FORFAIT = 'Forfait',
  FRAIS_DE_DEPLACEMENT = 'Frais de déplacement',
  GENETIQUE_MEDICALE = 'Génétique médicale',
  HEMATOLOGIE = 'Hématologie',
  MICROBIOLOGIE_INFECTIOLOGIE = 'Microbiologie-Infectiologie',
  MEDECINE_NUCLEAIRE = 'Médecine nucléaire',
  PDT = 'PDT',
  RADIOLOGIE_DIAGNOSTIQUE = 'Radiologie diagnostique',
  REMBOURSEMENT = 'Remboursement',
  TARIFICATION_NON_PREVUE = 'Tarification non prévue',
  ULTRASONOGRAPHIE = 'Ultrasonographie',
  VISITE = 'Visite',
  EPREUVES_DE_FONCTION_RESPIRATOIRE = 'Épreuves de fonction respiratoire',
}

export interface RamqSpecialistActCodeRoleUnit {
  role: string;
  units: string;
}

export interface RamqSpecialistActCodeMeasurementElement {
  code: string;
  name: string;
  unitType: string;
  effectiveStartDate: number;
  effectiveEndDate: number | null;
}

export interface RamqSpecialistActCodeRoleMetadata {
  role: string;
  effectiveEndDate: number | null;
  effectiveStartDate: number;
  roleName: string;
  specialty: UserSpecialtyId | null;
  specialtyName: UserSpecialty | null;
  units: number | null;
}

export interface RamqSpecialistActCodeTimedAttribute {
  key: string;
  value: unknown;
  effectiveStartDate: number | null;
  effectiveEndDate: number | null;
}

export interface RamqSpecialistActCodeDTO {
  code: string;
  description: string;
  translatedDescription: TranslatedText;
  natureType: RamqSpecialistActCodeNatureType;
  effectiveStartDate: number;
  effectiveEndDate: number | null;
  relatedCodes: string[];
  roles: number[];
  measurementElements: RamqSpecialistActCodeMeasurementElement[];
  isCabinetOnly: boolean;
  isSupplement: boolean;
  unitsBySpecialty: { [specialtyIdKey: string]: RamqSpecialistActCodeRoleUnit[] };
  roleMetadata: RamqSpecialistActCodeRoleMetadata[];
  timedAttributes: RamqSpecialistActCodeTimedAttribute[];
}
